//-----------------------------------------------------------------------
// <copyright file="azure-ad-demo.service.ts" company="LGT India">
//     Author: vanaraj
//     Copyright (c) LGT India. All rights reserved.
// </copyright>
//-----------------------------------------------------------------------
import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class AzureAdDemoService {
  loading: Subject<boolean> = new Subject();
}
